<template>
    <div class="mb-8">
        <h4 class="mb-3 md:mb-3.5">
            請勾選欲授權傳送變更資料之保險公司
        </h4>
        <h5>
            壽險公司
        </h5>
        <div
            v-if="lifeCompany"
            class="flex flex-wrap mt-3 mb-4"
        >
            <Checkbox
                v-for="(item, i) in lifeCompany"
                :key="i"
                v-model:checkedValues="lifeCompanyValues"
                :value="item.code"
                :text="item.name"
                class="mb-2"
            />
        </div>
        <h5>
            產險公司
        </h5>
        <div
            v-if="propertyCompany"
            class="flex flex-wrap mt-3 mb-4"
        >
            <Checkbox
                v-for="(item, i) in propertyCompany"
                :key="i"
                v-model:checkedValues="propertyCompanyValues"
                :value="item.code"
                :text="item.name"
                class="mb-2"
            />
        </div>
        <p class="text-error">
            您本次透過保險業通報作業系統篩選出有投保且符合保全聯盟鏈轉送申請公司，您仍可勾選欲轉送變更資料於其他保險公司。
        </p>
        <h4 class="mb-3 md:mb-3.5">
            保全契約變更申請轉送暨個資蒐集同意書
        </h4>
        <!-- 同意書 -->
        <TermsFrame
            need-layer
            :needGuideArrow="true"
            :need-checkbox="true"            
            checkbox-text="已閱讀並同意以上「保全契約變更申請轉送暨個資蒐集同意書」之告知事項"
            height="h-[18.75rem]"
            :content="term"
            :initScroll="true"
            @isAgree="value=> isAgree = value"
        />
    </div>
</template>
<script>
import { ref, effect, toRefs, watch } from 'vue';
import TermsFrame from '@/components/template/TermsFrame.vue';
import Checkbox from '@/components/checkboxs/Checkbox.vue';

export default {
    components: {
        TermsFrame,
        Checkbox,
    },
    props: {
        isFormReady: {
            type: Boolean,
            default: false,
        },
        isAgreeNotify: {
            type: String,
            default: 'N',
        },
        term: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },        
        companies: {
            type: Object,
            required: true,
        },
        pupConfirm: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:isFormReady', 'update:requestBody'],
    setup(props, { emit }) {
        const isAgree = ref(false);
        const lifeChecked = props.companies.lifeCompany.filter((p) => p.existLai === true).map((p) => { return p.code; });
        const propertyChecked = props.companies.propertyCompany.filter((p) => p.existLai === true).map((p) => { return p.code; });
        const lifeCompanyValues = ref(lifeChecked);
        const propertyCompanyValues = ref(propertyChecked);

        effect(() => {
            const isFinished = (lifeCompanyValues.value.length + propertyCompanyValues.value.length > 0) && isAgree.value === true;
            const requestBody = {
                agree: true, // 同意轉送
                agreeAllianceChainInfo: isAgree.value, // 同意條款
                lifeCheck: lifeCompanyValues.value,
                propertyCheck: propertyCompanyValues.value,
            };
            emit('update:requestBody', requestBody);
            emit('update:isFormReady', isFinished);
        });

        watch(() => props.companies, (newV) => {
            lifeCompanyValues.value = props.companies.lifeCompany.filter((p) => p.existLai === true).map((p) => { return p.code; });
            propertyCompanyValues.value = props.companies.propertyCompany.filter((p) => p.existLai === true).map((p) => { return p.code; });
        }, { immediate: false, deep: true });

        return {
            ...toRefs(props.companies),
            isAgree,
            lifeCompanyValues,
            propertyCompanyValues
        };
    },
};
</script>
